import { render, staticRenderFns } from "./basket-finish.vue?vue&type=template&id=963dfb68"
import script from "./basket-finish.vue?vue&type=script&lang=js"
export * from "./basket-finish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports